module.exports = __webpack_public_path__ + "static/synbioven-logo-cead5fe48d3ccfd9ee0465ec8cb8379d.png";